var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._b(
      {
        class: [_vm.$style["mds-loader"], _vm.classObject, _vm.sizeClass],
        attrs: {
          role: "progressbar",
          "aria-valuetext": _vm.ariaValuetext,
          "data-mds-version": _vm.version,
        },
      },
      "div",
      _vm.$attrs,
      false
    ),
    _vm._l(8, function (n) {
      return _c("div", {
        key: n,
        class: [
          _vm.$style["mds-loader__item"],
          _vm.$style[`mds-loader__item--${n}`],
        ],
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }